import type { DocumentKind } from "@/features/status/status-domain";

export const DEFAULT_PDF_RENDER_DPI = 200;

export const DOCUMENT_KIND_OPTIONS: ReadonlyArray<{
  id: DocumentKind;
  title: string;
  description: string;
  helpText: string;
}> = [
  {
    id: "fatture_ddt",
    title: "Fatture + DDT",
    description: "Per analizzare fatture e documenti di trasporto",
    helpText:
      "Analisi fatture e DDT: mismatch BL/container e report PDF finale.",
  },
  {
    id: "polizza_carico",
    title: "Polizza di carico",
    description: "Per estrarre BL e container attesi",
    helpText:
      "Analisi polizze di carico: estrazione BL e container attesi per la verifica.",
  },
];
